import { render, staticRenderFns } from "./addOrEditInformaion.vue?vue&type=template&id=a92773de&"
import script from "./addOrEditInformaion.vue?vue&type=script&lang=js&"
export * from "./addOrEditInformaion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a92773de')) {
      api.createRecord('a92773de', component.options)
    } else {
      api.reload('a92773de', component.options)
    }
    module.hot.accept("./addOrEditInformaion.vue?vue&type=template&id=a92773de&", function () {
      api.rerender('a92773de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/information/addOrEditInformaion.vue"
export default component.exports